module.exports = "/static/assets/98e078544198e1135c324f1b6d215820.png";